export default __webpack_public_path__ + "static/media/postgresql.9aed6868.svg";